import React from 'react';
import { Menu, X, ChartLine, UserCircle, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useSidebar } from "@/components/ui/sidebar";
import { useIsMobile } from "@/hooks/use-mobile";
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer";

const MobileNavbar: React.FC = () => {
  const { openMobile, setOpenMobile } = useSidebar();
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { signOut, profile } = useAuth();
  
  if (!isMobile) return null;

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };
  
  const handleProfileClick = () => {
    navigate('/admin');
  };

  // Get user initials
  const getUserInitials = () => {
    if (!profile?.nome) return 'U';
    
    const nameParts = profile.nome.split(' ').filter(part => part.length > 0);
    if (nameParts.length === 0) return 'U';
    
    if (nameParts.length === 1) {
      return nameParts[0].charAt(0).toUpperCase();
    }
    
    return (nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)).toUpperCase();
  };
  
  return (
    <div className="fixed top-0 inset-x-0 h-14 border-b bg-white z-40 flex items-center justify-between px-4">
      <div className="flex items-center gap-2">
        <Button 
          variant="ghost"
          size="sm" 
          onClick={() => setOpenMobile(true)}
          className="md:hidden"
        >
          <Menu className="h-5 w-5" />
        </Button>
        <div className="flex items-center gap-2">
          <div className="bg-blue-dark text-white p-1 rounded">
            <ChartLine className="h-5 w-5" />
          </div>
          <span className="font-bold text-xl text-blue-dark">BrokerBase</span>
        </div>
      </div>
      
      <div className="flex gap-2">
        <Drawer>
          <DrawerTrigger asChild>
            <Button variant="ghost" size="sm" className="rounded-full h-8 w-8 p-0">
              <div className="h-6 w-6 rounded-full bg-blue-dark text-white flex items-center justify-center text-xs font-bold">
                {getUserInitials()}
              </div>
            </Button>
          </DrawerTrigger>
          <DrawerContent>
            <DrawerHeader>
              <DrawerTitle>Menu</DrawerTitle>
            </DrawerHeader>
            <div className="px-4 py-2">
              <div className="flex flex-col space-y-2">
                <Button 
                  variant="ghost" 
                  className="justify-start" 
                  onClick={handleProfileClick}
                >
                  <UserCircle className="mr-2 h-5 w-5" />
                  <span>Meu Perfil</span>
                </Button>
                <Button 
                  variant="ghost" 
                  className="justify-start" 
                  onClick={handleSignOut}
                >
                  <LogOut className="mr-2 h-5 w-5" />
                  <span>Sair</span>
                </Button>
              </div>
            </div>
          </DrawerContent>
        </Drawer>
      </div>
    </div>
  );
};

export default MobileNavbar;
